import type { AppId } from "@/types";
import { AresApp } from "./AresApp";
import { AthenaApp } from "./AthenaApp";
import { GarlicApp } from "./GarlicApp";
import { ByoncApp } from "./ByoncApp";
import { AppGraphApp } from "./AppGraphApp";
import { WorkspaceManagerApp } from "./WorkspaceManagerApp";
import { TaskCommandCenterApp } from "./TaskCommandCenterApp";
import { WorkflowBuilderWindow } from "@/components/hive/workflows/WorkflowBuilderWindow";
import { ExecutionCenterWindow } from "@/components/hive/execution/ExecutionCenterWindow";
import { IntegrationCenterApp } from "./IntegrationCenterApp";
import { HooksApp } from "./HooksApp";
import { AgentsApp } from "./AgentsApp";
import { VerificationApp } from "./VerificationApp";
import { SettingsApp } from "./SettingsApp";
import { LauncherApp } from "./LauncherApp";

const MAP: Record<AppId, () => JSX.Element> = {
  ares: AresApp,
  athena: AthenaApp,
  garlic: GarlicApp,
  byonc: ByoncApp,
  appgraph: AppGraphApp,
  workspaces: WorkspaceManagerApp,
  tasks: TaskCommandCenterApp,
  workflows: WorkflowBuilderWindow,
  execution: ExecutionCenterWindow,
  integrations: IntegrationCenterApp,
  hooks: HooksApp,
  agents: AgentsApp,
  verification: VerificationApp,
  settings: SettingsApp,
  launcher: LauncherApp,
};

export function AppContent({ appId }: { appId: AppId }) {
  const Comp = MAP[appId];
  return <Comp />;
}
